<template>
  <div class="c12-wrap">
    <section ref="print">
      <div class="title">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>
              {{
              this.$moment(this.startDate).format("YYYY-MM-DD")
              }}
            </span>
            <span v-if="$parent.endTimeShow">
              至{{
              this.$moment(this.endDate).format("YYYY-MM-DD")
              }}
            </span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: flex-end">
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
          </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="c12-container">
        <div class="title">
          <div style="flex:3">楼区/楼层/账号</div>
          <div>主付房号</div>
          <div>名称</div>
          <div style="text-align:right">房价</div>
          <div style="text-align:right">服务费</div>
          <div style="text-align:right">定金</div>
          <div style="text-align:right">消费</div>
          <div style="text-align:right">余额</div>
          <div style="text-align:right">可用余额</div>
        </div>
        <div class="c12-item" v-for="(item, index) in list" :key="index">
          <div class="c12-area">{{ item.areaName }}</div>
          <div class="c12-inner-item" v-for="(item2, index) in item.floorList" :key="index">
            <div class="c12-floor">{{ item2.floorName }}</div>
            <div class="c12-line" v-for="(item3, index) in item2.roomList" :key="index">
              <div style="flex:3">{{ item3.areaName }}/{{ item3.floorName }}/{{ item3.accNo }}</div>
              <div>{{ item3.roomNo }}</div>
              <div>{{ item3.guestName }}</div>
              <div style="text-align:right">{{ curreny(item3.price) }}</div>
              <div style="text-align:right">{{ curreny(item3.serverFee) }}</div>
              <div style="text-align:right">{{ curreny(item3.earnest) }}</div>
              <div style="text-align:right">{{ curreny(item3.consumeAmount) }}</div>
              <div style="text-align:right">{{ curreny2(item3) }}</div>
              <div style="text-align:right">{{ curreny3(item3) }}</div>
            </div>
            <div class="c12-line2" style="font-weight:600">
              <div class="c12-line3"></div>
              <div>{{ item2.floorName }}</div>
              <div>应催收人数</div>
              <div>{{ item2.roomList.length }}人</div>
            </div>
          </div>
          <div class="c12-line2" style="font-weight:700">
            <div class="c12-line4"></div>
            <div>{{ item.areaName }}</div>
            <div>应催收人数</div>
            <div>{{ item.num }}人</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      list: [],
      list2: [],
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  computed: {
    tRoomArea() {
      return this.$store.state.tRoomArea;
    },
    tRoomFloor() {
      return this.$store.state.tRoomFloor;
    }
  },
  created() {
    this.$parent.closeshow();
    this.$parent.bbmc = "C12 前台宾客催款报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.chaxunvib = true;
    this.getData();
  },
  methods: {
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      this.list = [];
      this.getData();
    
    },
    getData() {
      this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
      this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
      this.startDate= this.$parent.startDate;
      this.endDate= this.$parent.endDate;
      let that = this;
      let loadingInstance = this.$loading({ text: "正在查询..." });
      postRequest("/reportFrontCash/selectReportRecipient", {
        hotelDate: this.$store.state.hotelInfo.dhoteltime
      }).then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.list2 = res.data;
          this.$store.state.preArrivalList = res.data;
          for (let i = 0; i < this.list2.length; i++) {
            for (let j = 0; j < this.tRoomArea.length; j++) {
              if (this.list2[i].area == this.tRoomArea[j].iid) {
                this.list2[i].areaName = this.tRoomArea[j].cdesc;
                break;
              }
            }
            for (let k = 0; k < this.tRoomFloor.length; k++) {
              if (this.list2[i].floor == this.tRoomFloor[k].iid) {
                this.list2[i].floorName = this.tRoomFloor[k].cdesc;
                break;
              }
            }
          }
          
          this.$store.state.preArrivalName = "C12 前台宾客催款报表";
          that.$parent.datacount = res.data.length;
          that.caculate();
        } else {
          this.$mymessage({
            content: res.code,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    },
    caculate() {
      let list = this.list;
      let list2 = JSON.parse(JSON.stringify(this.list2));
      // let obj = {
      //   area:list2[0].area
      // }
      // list.push(obj)
      
      
      for (let i = 0; i < list2.length; i++) {
        for (let j = 0; j < this.tRoomArea.length; j++) {
          if (list2[i].area == this.tRoomArea[j].iid) {
            list2[i].areaName = this.tRoomArea[j].cdesc;
            break;
          }
        }
        for (let k = 0; k < this.tRoomFloor.length; k++) {
          if (list2[i].floor == this.tRoomFloor[k].iid) {
            list2[i].floorName = this.tRoomFloor[k].cdesc;
            break;
          }
        }
      }

      
      for (let i = 0; i < list2.length; i++) {
        let isIn = false;
        for (let j = 0; j < list.length; j++) {
          if (list[j].area == list2[i].area) {
            isIn = true;
            break;
          }
        }
        if (!isIn) {
          list.push({
            area: list2[i].area,
            areaName: list2[i].areaName,
            floorList: []
          });
        }
      }

      for (let i = 0; i < list2.length; i++) {
        for (let j = 0; j < list.length; j++) {
          let isIn = false;
          if (list2[i].area == list[j].area) {
            for (let k = 0; k < list[j].floorList.length; k++) {
              if (list2[i].floor == list[j].floorList[k].floor) {
                isIn = true;
                break;
              }
            }
            if (!isIn) {
              list[j].floorList.push({
                floor: list2[i].floor,
                floorName: list2[i].floorName,
                roomList: []
              });
            }
          }
        }
      }

      for (let i = 0; i < list2.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (list2[i].area == list[j].area) {
            for (let k = 0; k < list[j].floorList.length; k++) {
              if (list2[i].floor == list[j].floorList[k].floor) {
                list[j].floorList[k].roomList.push(list2[i]);
              }
            }
          }
        }
      }

      for (let i = 0; i < list.length; i++) {
        list[i].num = 0;
        for (let j = 0; j < list[i].floorList.length; j++) {
          list[i].num += list[i].floorList[j].roomList.length;
        }
      }

      
      this.list = list;
    },
    curreny(data) {
      if (data != null && data != undefined) {
        data = Number(data).toFixed(2);
        return data;
      }
    },
    curreny2(item) {
      let yue =
        parseFloat(item.earnest) +
        parseFloat(item.creditAmount) -
        parseFloat(item.consumeAmount);
      return yue.toFixed(2);
    },
    curreny3(item) {
      let yue =
        parseFloat(item.earnest) +
        parseFloat(item.creditAmount) -
        parseFloat(item.consumeAmount) -
        parseFloat(item.price);
      return yue.toFixed(2);
    }
  }
};
</script>

<style scoped>
.c12-wrap {
  width: 100%;
  padding: 20px;
}
.c12-head > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.c12-head > div div {
  flex: 1;
  line-height: 22px;
  font-size: 14px;
}
.c12-head > div div:nth-child(2) {
  text-align: center;
}
.c12-head > div div:nth-child(3) {
  text-align: right;
}
.c12-container {
  margin-top: 10px;
  /* border-top: 1px solid black; */
  padding-top: 2px;
}
.c12-container > div {
  font-size: 14px;
  margin-bottom: 3px;
  /* background: cornflowerblue; */
}
.c12-container > div:last-child {
  border-bottom: 1px solid black;
  padding-bottom: 3px;
}
.c12-item {
  width: 100%;
}
.c12-area {
  width: 10%;
  text-align: left;
  padding-left: 3px;
}
.c12-floor {
  width: 10%;
  text-align: center;
}
.c12-line {
  width: 100%;
  display: flex;
}
.c12-line > div {
  flex: 2;
  text-align: center;
}
.c12-line2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3px;
}
.c12-line2 > div {
  width: 8%;
  text-align: center;
  margin-right: 2%;
}
.c12-line2 .c12-line3 {
  width: 20%;
  border-bottom: 1px solid black;
}
.c12-line2 .c12-line4 {
  width: 20%;
  border-bottom: 1px solid black;
  margin-left: 10%;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.title > div {
  flex: 2;
  text-align: center;
}
</style>